import React from 'react';
import { motion } from 'framer-motion';
export function Audience() {
  return <section className="py-16 md:py-24 px-4 bg-gray-50 border-t border-gray-200" data-id="element-11">
      <div className="max-w-4xl mx-auto" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-20" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-10 text-center" data-id="element-14">
            ¿PARA QUIÉN ES EL SISTEMA MEGAKIT?
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-15">
            <div className="bg-white p-8 rounded-lg border border-green-200" data-id="element-16">
              <h3 className="text-2xl font-bold text-green-500 mb-6 flex items-center gap-2" data-id="element-17">
                <span data-id="element-18">✅</span> Es para vos si:
              </h3>
              <ul className="space-y-4 text-gray-600" data-id="element-19">
                <li className="flex gap-3" data-id="element-20">
                  <span className="text-green-500 mt-1" data-id="element-21">✓</span>
                  <span data-id="element-22">
                    Tenés entre 20 y 45 años y notás que el pelo retrocede o se
                    afina.
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-23">
                  <span className="text-green-500 mt-1" data-id="element-24">✓</span>
                  <span data-id="element-25">
                    Todavía tenés folículos activos (aunque sean vellos finos).
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-26">
                  <span className="text-green-500 mt-1" data-id="element-27">✓</span>
                  <span data-id="element-28">
                    Querés una alternativa natural, sin químicos ni dependencia.
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-29">
                  <span className="text-green-500 mt-1" data-id="element-30">✓</span>
                  <span data-id="element-31">Podés dedicar 20 minutos por día durante 90 días.</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-lg border border-red-200" data-id="element-32">
              <h3 className="text-2xl font-bold text-red-500 mb-6 flex items-center gap-2" data-id="element-33">
                <span data-id="element-34">❌</span> No es para vos si:
              </h3>
              <ul className="space-y-4 text-gray-600" data-id="element-35">
                <li className="flex gap-3" data-id="element-36">
                  <span className="text-red-500 mt-1" data-id="element-37">✗</span>
                  <span data-id="element-38">
                    Tu calvicie ya está completamente avanzada sin ningún vello,
                    o buscás un milagro en 7 días.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto" data-id="element-39">
          <h2 className="text-3xl md:text-4xl font-bold text-gold mb-8" data-id="element-40">
            EL MOMENTO EN QUE TODO CAMBIA
          </h2>

          <div className="space-y-6 text-lg text-gray-600 text-left" data-id="element-41">
            <p className="font-bold text-gray-900" data-id="element-42">
              Alrededor de la semana 3 o 4, algo cambia.
            </p>
            <p data-id="element-43">
              Menos pelos en el desagüe. El cuero cabelludo se mueve con más
              libertad. Alguien te dice "¿te hiciste algo en el pelo?"
            </p>
            <p className="text-xl text-gold font-bold text-center mt-8 p-6 border border-gold/20 rounded-lg bg-gold/5" data-id="element-44">
              Lo que estás leyendo es el mapa para llegar a ese momento.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}